import { useMemo } from "react";
import {
  IReleaseTicket,
  IReleaseZone,
} from "~features/nonseated-reservation/nonseated-reservation.types";
import {
  MembershipsSoldForUserQuery,
  TicketsSoldForUserQuery,
} from "~graphql/sdk";
import { isVisible } from "./non-seated.helpers";

export function useFilterVisibleZonesAndTickets({
  zones,
  addons,
  selectedTickets = [],
  ticketsSoldForUser,
  isPresaleRelease,
  isAdmin,
}: {
  zones: IReleaseZone[];
  addons: IReleaseTicket[];
  selectedTickets: IReleaseTicket[];
  ticketsSoldForUser:
    | TicketsSoldForUserQuery["ticketsSoldForUser"]
    | MembershipsSoldForUserQuery["membershipsSoldForUser"];
  isPresaleRelease: boolean;
  isAdmin: boolean;
}) {
  return useMemo(() => {
    return {
      addons: addons.filter(
        (addon) =>
          isVisible(selectedTickets, addon, ticketsSoldForUser) || isAdmin
      ),
      zones: zones
        ?.map((zone: IReleaseZone) => {
          if (!zone.isActive) {
            return null;
          }

          const visibleTicketTypes = zone.ticketTypes.filter((ticketType) => {
            if (!ticketType.isActive && !isPresaleRelease) {
              return false;
            }

            if (
              !isVisible(selectedTickets, ticketType, ticketsSoldForUser) &&
              !isAdmin
            ) {
              return false;
            }

            return true;
          });

          return {
            ...zone,
            ticketTypes: visibleTicketTypes,
          };
        })
        .filter((zone) => {
          if (!zone) return false;
          const hasGallery = zone.imageGallery?.length > 0;
          const hasDescription = !!zone.description;
          const hasTicketTypes = zone.ticketTypes?.length > 0;

          return hasGallery || hasDescription || hasTicketTypes;
        }),
    };
  }, [
    zones?.length,
    addons?.length,
    JSON.stringify(selectedTickets),
    ticketsSoldForUser?.length,
    isPresaleRelease,
    isAdmin,
  ]);
}
